import { Link } from "react-router-dom";
import { categoryEntries } from "@/mocks/movies";

export default function CategoryEntry() {
  return (
    <section className="max-w-6xl mx-auto px-4 md:px-6 -mt-8 md:-mt-12 relative z-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        {categoryEntries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category?type=${entry.type}`}
            className="group relative h-40 md:h-52 rounded-lg overflow-hidden border border-background-200 cursor-pointer"
          >
            <img
              src={entry.image}
              alt={`${entry.title}分类入口`}
              title={`${entry.title} - 星辰影视分类`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-950/50 to-transparent" />
            <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-center">
              <span className="text-accent-300 text-xs font-medium">{entry.subtitle}</span>
              <h2 className="mt-1 font-heading font-bold text-2xl md:text-3xl text-white">
                {entry.title}
              </h2>
              <p className="mt-2 text-xs md:text-sm text-white/80 max-w-[16rem] leading-relaxed hidden sm:block">
                {entry.desc}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm text-white font-medium">
                共 {entry.count} 部作品
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}